<template lang="pug">
  section(class="courseoverview")
    div(class="course-header" @mouseover="onHover")
      div(class="course-title-container")

        div(class="icon-placeholder")
          img(:src="require(`@/assets/icons/${logo}`)")

        h3(class="course-title") {{ title }}

        p(class="course-subtitle") {{ subtitle }}

      div(class="button-container")
        div
          a(:href="url" target="_blank" class="btn btn-primary nowrap") HVU Course Site
        div
          a(:href="syllabus" target="_blank" class="btn btn-primary nowrap") Download Canvas Import File

        // -- end course-header --

    div(class="collapsible-container" ref="collapsible")
      div(class="collapsible-wrapper")
        p(v-if="description") {{ description }}
        h4 Topics covered include:

        ul(class="course-list")
          li(v-for="(item, index) in topics")
            a(v-if="item.link !== ''" :href="item.link") {{ item.text }}
            span(v-else) {{ item.text }}

        div(v-if="materials.length > 0" )
          h4 Included materials:

          ul(class="course-list")
            li(v-for="(item) in materials")
              span {{ item }}
          // -- end courseoverview --
</template>

<script>
export default {
  name: "CourseOverview",
  data() {
    return {
      id: null
    };
  },
  mounted() {
    // Assign a unique id attribute
    this.id = `collapsible-${this.item_index}`;
    this.$refs.collapsible.setAttribute("id", this.id);
  },
  methods: {
    onHover() {
      // Skip collapsing this item if its already collapsed
      const collapsed = this.$refs.collapsible.clientHeight > 0;
      if (collapsed) {
        return;
      }

      // Expand this item with variable height of its content
      const wrapper = this.$refs.collapsible.firstElementChild;
      this.$refs.collapsible.style.height = `${wrapper.clientHeight}px`;

      // Collapse all others
      const containers = document.getElementsByClassName(
        "collapsible-container"
      );

      for (let i = 0; i < containers.length; i += 1) {
        if (containers[i].getAttribute("id") !== this.id) {
          containers[i].style.height = 0;
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },

    subtitle: {
      type: String,
      default: "Subtitle"
    },

    url: {
      type: String,
      default: "#0"
    },

    syllabus: {
      type: String,
      default: "#0"
    },

    tour: {
      type: String,
      default: "#0"
    },

    logo: {
      type: String,
      default: "HVU-icon-transparent.svg"
    },

    item_index: {
      type: Number,
      default: 0
    },

    description: {
      type: String,
      default: undefined
    },

    topics: {
      type: Array,
      default: () => [
        {
          text: "Sample Video",
          link: ""
        }
      ]
    },

    materials: {
      type: Array,
      default: () => []
    }
  }
};
</script>
